var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui-avatar",class:[_vm.tone !== 'accent' && `ui-avatar--${_vm.tone}`, _vm.size !== 'md' && `ui-avatar--${_vm.size}`, _vm.big && 'ui-avatar--big'],attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }